module.exports = __webpack_public_path__ + "static/media/banner-carrefour_bkp.36918fc0.webp";